import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
`;

export const TabsContainer = styled.div`
  margin-bottom: 0;
  border-bottom: 1px solid rgb(205, 199, 209);
  padding: 0 32px;
  background: rgb(250, 249, 251);
  overflow: hidden;

  /* Align first tab with chart content; remove extra left gap from Tabs wrapper */
  & > div {
    padding-left: 0;
    margin-inline: 0;
  }
`;

export const ChartContent = styled.div`
  background: white;
`;

export const ChartPanel = styled.div<{ $visible: boolean }>`
  display: ${({ $visible }) => ($visible ? 'block' : 'none')};
`;
